
import { ref } from 'vue'



export function mapControl(mapApi: any, map: any) {
    // 3D
    const navi3DCtrl = ref()
    // 开关3D
    function switch3DCtrl(val: boolean) {
        if (val) {
            mapApi.value.addControl(navi3DCtrl.value)
        } else {
            mapApi.value.removeControl(navi3DCtrl.value)
        }
    }
    // 3D end
    // 比例尺
    const scaleCtrl = ref()
    // 开关比例尺
    function switchScaleCtrl(val: boolean) {
        if (val) {
            mapApi.value.addControl(scaleCtrl.value)
        } else {
            mapApi.value.removeControl(scaleCtrl.value)
        }
    }
    // 缩放
    const zoomCtrl = ref()
    // 设置缩放级别
    function setMinZoom(val: Number) {
        mapApi.value.setMinZoom(val)
    }
    function setMaxZoom(val: Number) {
        mapApi.value.setMaxZoom(val)
    }
    // 开关缩放
    function switchZoomCtrl(val: boolean) {
        if (val) {
            mapApi.value.addControl(zoomCtrl.value)
        } else {
            mapApi.value.removeControl(zoomCtrl.value)
        }
    }

    const clearCtrl = ref()
    // 是否显示清除所有覆盖物控件
    function switchClearCtrl(val: boolean) {
        if (val) {
            mapApi.value.addControl(clearCtrl.value)
        } else {
            mapApi.value.removeControl(clearCtrl.value)
        }
    }

    return {
        navi3DCtrl,
        switch3DCtrl,
        scaleCtrl,
        switchScaleCtrl,
        zoomCtrl,
        setMinZoom,
        setMaxZoom,
        switchZoomCtrl,
        clearCtrl,
        switchClearCtrl
    }
}






export function mapSkill(mapApi: any) {
    // 是否开启滚轮缩放地图层级
    function switchScrollZoom(val: boolean) {
        if (val) {
            mapApi.value.enableScrollWheelZoom()
        } else {
            mapApi.value.disableScrollWheelZoom()
        }
    }
    // 是否开启滚轮缩放地图层级
    function switchDragging(val: boolean) {
        if (val) {
            mapApi.value.enableDragging()
        } else {
            mapApi.value.disableDragging()
        }
    }
    // 是否开启双击缩放
    function switchDoubleClickZoom(val: boolean) {
        if (val) {
            mapApi.value.enableDoubleClickZoom()
        } else {
            mapApi.value.disableDoubleClickZoom()
        }
    }
    return {
        switchScrollZoom,
        switchDragging,
        switchDoubleClickZoom
    }
}



export function useMapApi(mapApi: any, map: any) {
    
}